<script>
    import { format } from "svelte-i18n";

    let { value, rowIndex, rowId, instructKey } = $props();

    function handleReportClick(event) {
        event.stopPropagation();
        if (value && typeof value.openReportModal === "function") {
            value.openReportModal(value.campaign || value);
        }
    }

    function handleImportClick(event) {
        event.stopPropagation();
        if (value && typeof value.openImportModal === "function") {
            value.openImportModal(value.campaign || value);
        }
    }
</script>

<div class="text-center text-nowrap">
    <button
        type="button"
        class="btn btn-default bg-light btn-xs me-1"
        title={$format("phishing.campaign.download_report")}
        onclick={handleReportClick}
    >
        <i class="fas fa-file-contract text-secondary me-1"></i>
        <span>{$format("phishing.campaign.report_button")}</span>
    </button>
    <button
        type="button"
        class="btn btn-default bg-light btn-xs"
        title={$format("phishing.campaign.import_results")}
        onclick={handleImportClick}
    >
        <i class="fas fa-file-upload text-secondary me-1"></i>
        <span>{$format("phishing.campaign.import_button")}</span>
    </button>
</div>

<style>
    button {
        position: relative;
        z-index: 2;
    }
</style>
